import { Text, Tooltip } from '@shared/components';
import { CarrierRate } from '@shared/types/quote';
import {
  getRateTotalDistanceDisplay,
  getRouteDuration,
  ratingMethodToLabel,
} from '@shared/utils/rates/rates';

export const DistanceDisplay = ({
  carrierRate,
  multiStopMileage,
  onRefresh,
}: {
  carrierRate?: CarrierRate;
  multiStopMileage?: {
    value: number;
    units: 'MI' | 'KM';
  };
  onRefresh?: () => Promise<void>;
}) => {
  const distance = multiStopMileage || carrierRate?.metadata?.mileage;

  if (!distance?.value) return null;

  const voomaMileageSource = 'Google';
  const ratingMethodSource = carrierRate
    ? ratingMethodToLabel(carrierRate.ratingMethod)
    : voomaMileageSource;
  const mileageSource = multiStopMileage?.value
    ? voomaMileageSource
    : ratingMethodSource;

  const totalDistanceDisplay = getRateTotalDistanceDisplay(distance);
  const estimatedDuration = getRouteDuration(distance);

  return (
    <div className="flex flex-col items-end gap-1">
      <Tooltip
        isInstant
        side="top"
        content={`Mileage sourced from ${mileageSource}`}
      >
        <div
          className="flex cursor-pointer items-center gap-1 px-1"
          onClick={onRefresh}
        >
          <Text className="text-gray-500" type="body-xs">
            {totalDistanceDisplay}
            {estimatedDuration ? ` (${estimatedDuration} hours)` : ''}
          </Text>
        </div>
      </Tooltip>
    </div>
  );
};
